export default __webpack_public_path__ + "static/media/uploadCover.bffa3d00.svg";